import React from "react";

import MainQuestion from "./MainQuestion";
import Button from "./Button";

import PUI from "./PUI";
import PUM from "./PUM";
import Neither from "./Neither";

function Traveller() {
  let questions = {
    travel: "Did you travel outside the country?",
    symptoms: "Do you have symptoms such as fever, cough or colds?",
    exposure: "Were you anywhere near a confirmed Covid-19 patient?",
  };

  let didTravel = React.useState("no answer");
  let hasSymptoms = React.useState("no answer");
  let nearCovidPatient = React.useState("no answer");

  const handleDidTravel = (evt) => {
    didTravel[1](evt.target.value);
  };

  function handleHasSymptoms(evt) {
    hasSymptoms[1](evt.target.value);
  }

  function handleNearCovidPatient(evt) {
    nearCovidPatient[1](evt.target.value);
  }

  return (
    <div className="mx-auto">
      {/* Summary of User's Answers */}
      <div>
        {didTravel[0] !== "no answer" && (
          <div className="bg-white border p-4 m-5">
            <h6>Your Answers</h6>
            {didTravel[0] !== "no answer" && (
              <p className="mb-0">Travel: {didTravel[0]}</p>
            )}
            {hasSymptoms[0] !== "no answer" && (
              <p className="mb-0">Symptoms: {hasSymptoms[0]}</p>
            )}
            {nearCovidPatient[0] !== "no answer" && (
              <p className="mb-0">Near Covid Patient: {nearCovidPatient[0]}</p>
            )}
          </div>
        )}
      </div>

      {/* First Question */}
      {didTravel[0] === "no answer" &&
        hasSymptoms[0] === "no answer" &&
        nearCovidPatient[0] === "no answer" && (
          <div className="bg-white border p-4 m-5">
            <MainQuestion mainQuestion={questions.travel} />
            <Button value="yes" label="Yes" onClick={handleDidTravel} />
            <Button value="no" label="No" onClick={handleDidTravel} />
          </div>
        )}
      {/* Next Question */}
      {didTravel[0] === "yes" &&
        hasSymptoms[0] === "no answer" &&
        nearCovidPatient[0] === "no answer" && (
          <div className="bg-white border p-4 m-5">
            <MainQuestion mainQuestion={questions.symptoms} />
            <Button value="yes" label="Yes" onClick={handleHasSymptoms} />
            <Button value="no" label="No" onClick={handleHasSymptoms} />
          </div>
        )}
      {/* Next Question */}
      {didTravel[0] === "no" &&
        hasSymptoms[0] === "no answer" &&
        nearCovidPatient[0] === "yes" && (
          <div className="bg-white border p-4 m-5">
            <MainQuestion mainQuestion={questions.symptoms} />
            <Button value="yes" label="Yes" onClick={handleHasSymptoms} />
            <Button value="no" label="No" onClick={handleHasSymptoms} />
          </div>
        )}
      {/* Next Question */}
      {didTravel[0] === "no" &&
        hasSymptoms[0] === "no answer" &&
        nearCovidPatient[0] === "no answer" && (
          <div className="bg-white border p-4 m-5">
            <MainQuestion mainQuestion={questions.exposure} />
            <Button value="yes" label="Yes" onClick={handleNearCovidPatient} />
            <Button value="no" label="No" onClick={handleNearCovidPatient} />
          </div>
        )}

      {/* Result */}
      {didTravel[0] === "yes" &&
        hasSymptoms[0] === "yes" &&
        nearCovidPatient[0] === "no answer" && <PUI />}
      {/* Next Result */}
      {didTravel[0] === "no" &&
        hasSymptoms[0] === "no answer" &&
        nearCovidPatient[0] === "no" && <Neither />}
      {/* Next Result */}
      {didTravel[0] === "no" &&
        hasSymptoms[0] === "no" &&
        nearCovidPatient[0] === "none" && <Neither />}
      {/* Next Result */}
      {didTravel[0] === "yes" &&
        hasSymptoms[0] === "no" &&
        nearCovidPatient[0] === "no answer" && <PUM />}
      {/* Next Result */}
      {didTravel[0] === "no" &&
        hasSymptoms[0] === "yes" &&
        nearCovidPatient[0] === "no" && <PUM />}
      {/* Next Result */}
      {didTravel[0] === "no" &&
        hasSymptoms[0] === "no" &&
        nearCovidPatient[0] === "yes" && <PUM />}
      {/* Next Result */}
      {didTravel[0] === "no" &&
        hasSymptoms[0] === "yes" &&
        nearCovidPatient[0] === "yes" && <PUI />}

      {/* Start Over */}
      <div>
        <a href="/">
          <p className="text-center">Start Over</p>
        </a>
      </div>
    </div>
  );
}

export default Traveller;
